import { c as _c } from "react/compiler-runtime";
import join from 'url-join';
import { useOptimizely } from '@libs/common-next';
import css from './new.module.scss';
export function New() {
  const $ = _c(8);
  const {
    instance
  } = useOptimizely();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>Add feature flag</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Learn<a className={css.link} href="https://petsmart.atlassian.net/wiki/x/BwARbg" target="_blank">how to set up</a>and rollout a new feature flag in the Optimizely dashboard.</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== instance) {
    t2 = instance?.getProjectConfig()?.projectId;
    $[2] = instance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${t2}`;
  let t4;
  if ($[4] !== t3) {
    t4 = join(" https://app.optimizely.com/v2/projects", t3, "flags/list");
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className={css.add}>{t0}{t1}<a target="_blank" href={t4}>Set up</a></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}